import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { planIncrementEntryPoint } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-increment/entrypoint.tsx';
import { plansHorizontalNavigationEntryPoint } from '@atlassian/jira-horizontal-nav-plans/entrypoint.tsx';

export const planIncrementPageEntryPoint = createPageEntryPoint({
	main: planIncrementEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
	horizontalNavigation: plansHorizontalNavigationEntryPoint,
});

export const planIncrementPageEntryPointWithoutHorizontalNavigation = createPageEntryPoint({
	main: planIncrementEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
});
